import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import type Retracked from 'js/app/retracked';

export type RetrackedContext = {
  _eventData: Retracked.TrackingContextData;
  _withTrackingData?: () => Retracked.TrackingData;
};

const withRetrackedContextAsProps =
  <PropsOut extends RetrackedContext & PropsIn, PropsIn>() =>
  (WrappedComponent: React.ComponentType<PropsOut>) => {
    return class Wrapper extends React.Component<PropsIn> {
      static displayName = `withRetrackedContextAsProps(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`;

      static contextTypes = {
        _eventData: PropTypes.object,
        _withTrackingData: PropTypes.func,
      };

      declare context: LegacyContextType<typeof Wrapper.contextTypes>;

      render() {
        // @ts-expect-error TS2322: Type Readonly<PropsIn> & LegacyContextType<{ _eventData: Requireable<object>; _withTrackingData: Requireable<(...args: any[]) => any>; }> is not assignable to type IntrinsicAttributes & PropsOut
        return <WrappedComponent {...this.props} {...this.context} />;
      }
    };
  };

export default withRetrackedContextAsProps;
